export const getDialogManagerState = ({ dialogManager }) => dialogManager
